import { JbTabindexPipe } from './tabindex.pipe';

export const TABINDEX_PIPE_DECLARATIONS = [JbTabindexPipe];

export * from './tabindex.pipe';
